import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/autocomplete-municipality'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  return {
    html,
    validators: [
      function (state, config, _) {
        const { matched } = state;
        if (matched) {
          return false;
        }

        return language['not_valid_municipality'];
      },
    ],
    config: {
      behaviour: 'text-input',
      validators: ['mandatory'],
    },
  };
}
